export const BANK_PAYMENTS_TYPE = "BANK_OF_POINTS";
export const ONLINE_PAYMENTS_TYPE = "ONLINE_PAYMENT";
